// extracted by mini-css-extract-plugin
export var arrow = "_3w-6";
export var changeItem = "_3w-3";
export var changesHeader = "_3w-1";
export var changesList = "_3w-2";
export var container = "_3w-0";
export var pathLabel = "_3w-4";
export var value = "_3w-7";
export var valuesContainer = "_3w-5";